import React, { useRef } from "react";
import { useAtom } from "jotai";
import { costingState } from "./state";
import type { BicyleCostingOptions } from "./valhalla";

const Control = ({
	costing_option,
	step = 0.1,
	zero_label = costing_option,
	hundo_label = costing_option,
	label,
	invert = false,
	neutral = false,
}: {
	costing_option: keyof BicyleCostingOptions;
	step?: number;
	zero_label?: string;
	hundo_label?: string;
	label?: string;
	invert?: boolean;
	neutral?: boolean;
}) => {
	const [costing_options, updateCosting] = useAtom(costingState);
	let value = costing_options[costing_option];
	if (invert && value !== undefined) {
		value = 1.0 - value;
	}
	const arc = neutral ? 90 : 180;
	const rotate = arc - (value || 0) * arc;
	const zero = invert ? hundo_label : zero_label;
	const hundo = invert ? zero_label : hundo_label;
	const ref = useRef<HTMLDivElement>(null);
	const rotateStyle = { "--rotate": `${rotate}deg` } as React.CSSProperties;
	return (
		<div className="input" ref={ref}>
			<div className="button slider-label">{label}</div>
			<fieldset className="slider">
				<input
					min="0"
					max="1"
					step={step}
					type="range"
					value={value}
					name={costing_option}
					id={costing_option}
					onChange={(e) => {
						let raw = parseFloat(e.target.value);
						if (invert) {
							raw = 1.0 - raw;
						}
						updateCosting((prev) => ({
							...prev,
							[costing_option]: raw,
						}));
					}}
				/>
				<div className="label">
					<label htmlFor={costing_option}>{zero}</label>
					<output>
						{" "}
						<span style={rotateStyle} className="thumb">
							👍
						</span>
					</output>
					<label htmlFor={costing_option}>{hundo}</label>
				</div>
			</fieldset>
		</div>
	);
};

export default Control;
